var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'tags-item',
    'columns',
    'is-mobile',
    'is-gapless',
    'is-vcentered',
    { 'tags-item--selected': _vm.isSelected },
  ]},[_c('h3',{staticClass:"tags-item__name"},[_vm._v(_vm._s(_vm.nameFormatted))]),_c('p',{staticClass:"tags-item__count"},[_vm._v(_vm._s(_vm.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }